import * as React from 'react'

import Grid from '@material-ui/core/Grid'

import { Study }                     from '../../../api'
import { FormikFormChunkProps }      from '../../../types'
import { AbstractedFormikTextField } from '../../atoms'

const EducationalAchievementChunk: React.SFC<FormikFormChunkProps<Study>> = props => (
  <Grid container spacing={8}>
    <Grid item xs={12}>
      <AbstractedFormikTextField
        autoFocus
        fullWidth
        margin={'dense'}
        identifier={'name'}
        {...props}
      />
    </Grid>
    <Grid item xs={12}>
      <AbstractedFormikTextField
        fullWidth
        margin={'dense'}
        identifier={'school'}
        {...props}
      />
    </Grid>
  </Grid>
)

export default EducationalAchievementChunk



// WEBPACK FOOTER //
// ./src/components/forms/chunks/EducationalAchievementChunk.tsx